// @flow
import async from 'async';

import PusherStore from 'app/stores/PusherStore';
import CentrifugeStore from 'app/stores/CentrifugeStore';

import Logger from 'app/lib/Logger';
import LegacyDispatcher from 'app/lib/legacyDispatcher';

declare var jQuery: {
  ajax: (options: { url: string, data: mixed, success: (result: mixed) => mixed }) => mixed
};

// Takes websocket events (which are just event names and urls) - downloads the
// payload at the URL, then triggeres a dispatcher event with the event name and
// the contents of the URL.
//
// We don't send the payload through pusher because by the time it gets to the
// client, it's usually out of date, and our payloads are much bigger than
// pusher will allow.

class Websocket {
  queue: {
    push: (data: mixed, callback: (result: mixed) => mixed) => mixed
  };

  constructor() {
    this.queue = async.queue((payload, callback) => {
      Logger.info(`[Ajax] GET ${payload.url}`);

      return jQuery.ajax({
        url: payload.url,
        data: payload.urlData,
        success(result) {
          return callback(result);
        }
      });
    });

    // Payload for `websocket:event` has: {event,id,url}
    PusherStore.on("websocket:event", (payload) => {
      Logger.info("[Buildkite.Websocket] Pusher websocket:event:", payload);

      LegacyDispatcher.emit(
        payload.event,
        Object.assign(
          {
            fetcher: (urlData) => {
              const newPayload = Object.assign({ urlData }, payload);

              return new Promise((fulfill) => this.queue.push(newPayload, (result) => fulfill(result)));
            }
          },
          payload
        )
      );
    });

    // Payload for `websocket:event` has: {subevent,id,url}
    CentrifugeStore.on("websocket:event", (payload) => {
      Logger.info("[Buildkite.Websocket] Centrifuge websocket:event:", payload);

      LegacyDispatcher.emit(
        payload.subevent,
        Object.assign(
          {
            fetcher: (urlData) => {
              const newPayload = Object.assign({ urlData }, payload);

              return new Promise((fulfill) => this.queue.push(newPayload, (result) => fulfill(result)));
            }
          },
          payload
        )
      );
    });
  }

  onConnect(callback: () => mixed) {
    PusherStore.on("connected", () => callback());
    CentrifugeStore.on("connect", () => callback());
  }
}

export default new Websocket();
